import { type FunctionComponent } from 'react'
import { T as TolgeeT } from '@tolgee/react'

import type { TranslateComponentProps } from './types'
import { toTagParams } from './utils'

export const T: FunctionComponent<TranslateComponentProps> = ({ keyName, parameters, children }) => {
  return (
    <TolgeeT keyName={keyName} params={toTagParams(parameters)}>
      {children}
    </TolgeeT>
  )
}
